// Video Embed - click to play
let videoEmbedBlock = document.querySelectorAll('.embedded-video');
if (videoEmbedBlock) {
    [].forEach.call(videoEmbedBlock, function (video) {
        let playTarget = video.querySelector('.embedded-video-inner');
        let epiVideo = video.querySelector('video');
        let ytVideo = video.querySelector('iframe');
        playTarget.addEventListener('click', function () {
            video.classList.add('embedded-video-isPlaying');
            if (epiVideo) {
                epiVideo.play();
            }
            if (ytVideo) {
                ytVideo.src += '?autoplay=1&rel=0';
            }
        });
    });
}

// Fullscreen Functionality
let fullscreenButtons = document.querySelectorAll('.fullscreen-button');
if (fullscreenButtons) {
    [].forEach.call(fullscreenButtons, function (button) {
        button.addEventListener('click', function () {
            button.parentElement.classList.toggle('fullscreen-media');
            document.body.classList.toggle('fullscreenIsOpen');
        });
    });
}

/* 11/09/2017 - JH: Commenting this out instead of removing in case client changes mind in the future and wants this fucntionality again
// Adding container when blocks are stacked
let allEmbeddedMedia = document.querySelectorAll('.embedded-media');
if (allEmbeddedMedia) {
    
    [].forEach.call(allEmbeddedMedia, function (block) {
        if(!block.classList.contains('sidecaption') || !block.classList.contains('sidecaption-right') || !block.classList.contains('inline-image') || !block.classList.contains('inline-image-right'))
        {
            let blockPrevSibling = block.previousElementSibling;
            let blockNextSibling = block.nextElementSibling;
            if (blockPrevSibling
                &&
                !blockPrevSibling.classList.contains('embedded-media')
                &&
                blockNextSibling
                &&
                blockNextSibling.classList.contains('embedded-media')) {

                block.insertAdjacentHTML('beforebegin', '<div class="embedded-media-container"></div>');
                let blockPlaceholder = block.previousElementSibling;

                let groupedMedia = document.createDocumentFragment();
                groupedMedia.appendChild(block);

                while (blockNextSibling !== null && blockNextSibling.classList.contains('embedded-media')) {
                    let tempSibling = blockNextSibling.nextElementSibling;
                    groupedMedia.appendChild(blockNextSibling);
                    blockNextSibling = tempSibling;
                }
                blockPlaceholder.appendChild(groupedMedia);
            }
        }
    });
}

// Grouping captions in stacked media blocks
let stackedMediaBlocks = document.querySelectorAll('.embedded-media-container');
if (stackedMediaBlocks) {
    [].forEach.call(stackedMediaBlocks, function (containerBlock) {
        let mediaBlock = containerBlock.querySelectorAll('.embedded-media');
        let groupedCaptions = [];
        [].forEach.call(mediaBlock, function (individualBlock) {
            let caption = individualBlock.querySelector('.embedded-media-caption');
            if (caption) {
                groupedCaptions.push(caption.innerHTML);
            }
        });
        let captionContainer = containerBlock.querySelectorAll('.embedded-media-caption');
        [].forEach.call(captionContainer, function (cap, index) {
            if ((index + 1) === captionContainer.length) { // if last caption in stacked group
                let lastBlockInitialCaption = cap.innerHTML;
                var captionsString = groupedCaptions.join('');

                // Fullscreen check - for fullscreen, captions are normal. On-page, captions are combined.
                let lastBlockFullscreenButton = containerBlock.querySelectorAll('.fullscreen-button')[index];
                function updateLastCaption() {
                    if (document.body.classList.contains('fullscreenIsOpen') && window.innerWidth > 1000) {
                        cap.innerHTML = lastBlockInitialCaption;
                        return;
                    }
                    cap.innerHTML = captionsString;
                }
                updateLastCaption();

                window.addEventListener('resize', updateLastCaption);

                if (lastBlockFullscreenButton) {
                    lastBlockFullscreenButton.addEventListener('click', updateLastCaption);
                }
            }
        });
    });
} */

// Double Embedded Media - When only one caption exists, add class to double container block
let doubleBlocks = document.querySelectorAll('.embedded-double');
if (doubleBlocks) {
    [].forEach.call(doubleBlocks, function (double) {
        let captions = double.querySelectorAll('.embedded-media-caption');
        if (captions.length === 1) {
            double.classList.add('single-caption');
            //get caption from block that has one
            let captionHtml = captions[0].innerHTML;
            captions[0].parentElement.classList.add('with-caption');
            //put caption in 'long' caption container
            let newCaptionContainer = double.querySelector('.embedded-double-caption');
            newCaptionContainer.innerHTML = captionHtml;

            //copy caption into the other media block for fullscreen:
            //1. find block without caption
            let blockWithoutCaption = double.querySelector('.embedded-media:not(.with-caption)');
            //2. create new caption element with class and content from existing caption
            let cloneCaptionContainer = document.createDocumentFragment();
            let cloneCaptionContainerEl = document.createElement('small');
            cloneCaptionContainerEl.innerHTML = captionHtml;
            cloneCaptionContainerEl.classList.add('embedded-media-caption');
            //3. append new element onto doc fragment (using doc fragment for better performance)
            cloneCaptionContainer.appendChild(cloneCaptionContainerEl);
            //4. append new doc fragment onto block without caption
            blockWithoutCaption.appendChild(cloneCaptionContainer);
        }
    });
}

//Override default width for inline embedded media blocks
let inlineBlocks = document.querySelectorAll('[data-widthOverrideInline]');
if (inlineBlocks) {
    function setInlineWidth() {
        [].forEach.call(inlineBlocks, function (block) {
            let userSetWidth = block.getAttribute('data-widthOverrideInline');

            //Desktop
            if (window.innerWidth > 1000) {
                block.style.width = `calc(((100% - 190px) * .${userSetWidth}) - 30px)`; //190 & 30 are margins, same calculation as in stylesheets
            }
                //Tablet
            else if (window.innerWidth <= 1000 && window.innerWidth > 640) {
                block.style.width = `calc((100% * .${userSetWidth}) - 30px)`;
            }
                //Mobile
            else {
                block.style.width = '100%';
            }
        });
    }
    setInlineWidth();

    // Resize event handler and function calls
    window.addEventListener('resize', function () {
        window.requestAnimationFrame(setInlineWidth);
    });
}

//Override default width for side caption embedded media blocks
let sideCaptionBlocks = document.querySelectorAll('[data-widthOverrideSide]');
if (sideCaptionBlocks) {
    function setSideCaptionWidth() {
        [].forEach.call(sideCaptionBlocks, function (block) {
            let userSetWidth = block.getAttribute('data-widthOverrideSide');
            let mediaElement = block.querySelector('.embedded-photo-img, .embedded-video-inner');
            let captionElement = block.querySelector('.embedded-media-caption');
            let captionWidth = 100 - userSetWidth;

            if (block.classList.contains('sidecaption-right')) {
                var fullscreenButtonElement = block.querySelector('.fullscreen-button');
            }

            //Desktop, Tablet
            if (window.innerWidth > 640) {
                mediaElement.style.width = `${userSetWidth}%`;
                captionElement.style.width = `${userSetWidth}%`;
                if (fullscreenButtonElement) {
                    fullscreenButtonElement.style.left = `calc(${userSetWidth}% - 32px)`; //magic # matches styles, margins
                }
            }

                //Mobile
            else {
                mediaElement.style.width = '100%';
                captionElement.style.width = '100%';
                if (fullscreenButtonElement) {
                    fullscreenButtonElement.style.left = 'auto';
                }
            }
        });
    }
    setSideCaptionWidth();

    // Resize event handler and function calls
    window.addEventListener('resize', function () {
        window.requestAnimationFrame(setSideCaptionWidth);
    });
}

// Decreasing space between non-stacked embedded media blocks
let allEmbeddedMediaParagraphSandwiches = document.querySelectorAll('.embedded-media + p + .embedded-media, .embedded-media-container + p + .embedded-media-container');
if (allEmbeddedMediaParagraphSandwiches) {
    [].forEach.call(allEmbeddedMediaParagraphSandwiches, function (block) {
        let paragraph = block.previousElementSibling;
        if (paragraph.innerHTML === '&nbsp;') {
            block.style.marginTop = 0;
            paragraph.style.lineHeight = 0;
            block.firstElementChild.style.marginTop = 0;
        }
    });
}